import { DOCUMENT } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { InstacitiNewService } from "../service/instaciti-new.service";
declare function Tooltip(): any;
declare function triggerCarousel(): any;
declare function CustomAutoScroll(): any;

@Component({
  selector: "app-school-details",
  templateUrl: "./school-details.component.html",
  styleUrls: ["./school-details.component.css"],
})
export class SchoolDetailsComponent implements OnInit {
  handle: string;
  schoolDetails;
  schoolForm;
  board;
  languages;
  academics = [];
  classes = [];
  academicDetails = [];
  selectedAcademic;
  selectedClass;
  selectedSpecialization;
  selectedAcademicDetails;
  location;
  arrSpecialization = [];
  specialization=[];
  amenityCategories = [];
  amenities = [];
  nearbySchools = [];
  constructor(
    @Inject(DOCUMENT) private document: any,
    private routeParam: ActivatedRoute,
    private service: InstacitiNewService,
    public title: Title,
    private route: Router
  ) {
    document.body.classList.remove("mat-typography");
    title.setTitle("InstaCiti Portal");
  }

  ngOnInit(): void {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    this.loadToolTipJS();
    this.location = this.routeParam.snapshot.params["locality"];
    this.getSchoolDetails();
  }

  loadToolTipJS() {
    setTimeout(() => {
      Tooltip();
      CustomAutoScroll();
    }, 400);
    setTimeout(() => {
      triggerCarousel();
    }, 4000);
  }

  getSchoolDetails() {
    this.handle = this.routeParam.snapshot.params["handle"];
    this.service.getSchoolInfo(this.handle).subscribe((res) => {
      this.schoolDetails = res.ManikJSon[0].JSon0[0];
      console.log("this.schoolDetails",this.schoolDetails);
      
      this.academics = res.ManikJSon[0].JSon3;
      this.selectedAcademic = this.academics.length ? this.academics[0] : {};
      this.classes = res.ManikJSon[0].JSon4;
      this.selectedClass = this.classes.length
        ? this.classes[0].MasterClassID
        : 0;
      console.log("Zxcfg",this.classes);
      
      this.arrSpecialization = res.ManikJSon[0].JSon5;
      this.academicDetails = res.ManikJSon[0].JSon6;
      this.nearbySchools = res.ManikJSon[0].JSon7;
      this.amenities = res.ManikJSon[0].JSon8;
      this.amenities.forEach((amenity) => {
        if (!this.amenityCategories.includes(amenity.Grp)) {
          this.amenityCategories.push(amenity.Grp);
        }
      });
      console.log(this.amenityCategories);
      this.getSpecializationDetails();
      this.getSchoolFormData("a9ba8311-35bf-4918-a066-80e03ada5477");
    });
  }

  getSchoolFormData(schoolHandle: string) {
    this.service.getSchoolFormData(schoolHandle).subscribe((res) => {
      this.schoolForm = res.ManikJSon[0];
      const boards = this.schoolForm.JSon1.filter((element) => {
        return this.schoolDetails.EduBoardCSV.includes(
          element.DataValue
        );
      });
      this.board = boards[0].DataText;
      let lang = [];
      this.schoolForm.JSon4.forEach((element) => {
        if (this.schoolDetails.LanguageCSV.includes(element.DataValue)) {
          lang.push(element.DataText);
        }
      });
      this.languages = lang.join(",");
    });
  }

  onMouseOver(infoWindow, $event: MouseEvent) {
    infoWindow.open();
  }

  // Marker MouseOut Function
  onMouseOut(infoWindow, $event: MouseEvent) {
    infoWindow.close();
  }
  GetFloat(input: string): number {
    return parseFloat(input);
  }
  goToHome() {
    this.route.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.route.navigateByUrl("");
  }
  goToEDU() {
    this.route.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.route.navigateByUrl(
      this.routeParam.snapshot.params["locality"] + "/education"
    );
  }

  getSpecializationDetails() {
    console.log("here",this.selectedClass);
    
    this.specialization = this.arrSpecialization.filter((element) => {
      return element.MasterClassID == this.selectedClass;
    });
    if (this.specialization.length) {
      this.selectedSpecialization = this.specialization[0].SpecializationID;
    }
    this.getAcademicDetails();
  }
  getAcademicDetails() {
    console.log("zxvc",this.academicDetails);
    
    this.selectedAcademicDetails = this.academicDetails.find((element) => {
      return (
        element.AcademicYearID ==
          this.selectedAcademic.AcademicYearID &&
        element.MasterClassID == this.selectedClass &&
        (!this.selectedSpecialization ||
          (this.selectedSpecialization &&
            element.SpecializationID ==
              this.selectedSpecialization))
      );
    });

    console.log(this.selectedAcademicDetails);
  }
  openSchool(handle: string) {
    this.route.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.route.navigateByUrl(
      this.routeParam.snapshot.params["locality"] + "/education/" + handle
    );
  }
  scrollToElement($element): void {
    $element.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  }
}
